import axios from 'axios'; 

import graphSettings from '../config/graphSettings';
import { getAuthorizationHeader } from '../utils/auth';

export default {
	// maybe put accessToken in an interceptor for axios or save it in local storage
	// it's recommend to acquire an accces-token before any request to any protected api
	getProfile: (accessToken: string) => axios.get(`${graphSettings.baseUrl}/me`, { headers: getAuthorizationHeader(accessToken) }),
};
